import React from 'react';

import { Card } from 'antd';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import { dateService } from 'v2/services/date';

import BankSlipInstallment from './bankSlipIntallment';
import { BuyerDetails } from './buyerDetails';
import GetCcbTerm from './CcbTerm/getCcbTerm';
import { ChangePaymentMethod } from './changePaymentMethod';
import InvoiceDetails from './invoiceDetails';
import ProducerContact from './producerContact';
import RefundActions from './refundActions';

interface TicketProps {
  delivery: ShoppingDelivery;
  closeQuickView: () => void;
}

const Ticket = ({ delivery, closeQuickView }: TicketProps) => {
  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-col gap-3 sm:flex-row'>
        <div
          className='h-28 w-28 max-w-28 shrink-0 rounded bg-neutral-50 bg-cover bg-center bg-no-repeat'
          style={{ backgroundImage: `url(${delivery.product.image})` }}
        />

        <div>
          <h2 className='mb-4 text-base'>{delivery.product.title}</h2>
        </div>
      </div>

      <BuyerDetails delivery={delivery} />

      <Card size='small' title='Informações do evento'>
        <div className='flex flex-col gap-1'>
          <div className='text-sm'>
            <span className='font-semibold'>Data:</span>{' '}
            {delivery.product.event.date
              ? dateService.dateToString(new Date(delivery.product.event.date), 'dd/MM/yyyy')
              : '-'}
          </div>
          <div className='text-sm'>
            <span className='font-semibold'>Horário:</span>{' '}
            {delivery.product.event.date
              ? dateService.dateToString(new Date(delivery.product.event.date), 'H:mm')
              : '-'}
          </div>
          <div className='text-sm'>
            <span className='font-semibold'>Endereço:</span> {' ' + delivery.product.event.address.street + ', '}
            {delivery.product.event.address.number + ' - '}
            {delivery.product.event.address.neighborhood + ' - '}
            {delivery.product.event.address.city + ' - '}
            {delivery.product.event.address.state}
          </div>
        </div>
      </Card>

      {delivery?.producer.showProducerContactInformation && <ProducerContact delivery={delivery} />}

      {!delivery.unlimited_installment && !delivery?.bankslip_installments && <InvoiceDetails delivery={delivery} />}

      {!delivery.unlimited_installment && delivery?.bankslip_installments && (
        <BankSlipInstallment delivery={delivery} />
      )}

      <RefundActions delivery={delivery} />

      {delivery.unlimited_installment && <ChangePaymentMethod delivery={delivery} closeQuickView={closeQuickView} />}

      <GetCcbTerm delivery={delivery} />
    </div>
  );
};

export default Ticket;
